module.exports = ".form-select {\n  font-size: 1.25rem;\n}\n\n.big-checkbox {\n  width: 30px;\n  height: 30px;\n  float: left;\n}\n"